import { AuthService } from '../../shared/services/auth.service';
import { Router } from '@angular/router';
import { UserService } from '../../shared/services/user.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GCValidators } from '../../shared/validators/gc-validator';
/**
 * Login component
 */
var LoginComponent = (function () {
    function LoginComponent(auth, router, user) {
        this.auth = auth;
        this.router = router;
        this.user = user;
        this.loginForm = new FormGroup({
            email: new FormControl('', [Validators.required, GCValidators.validateEmail]),
            password: new FormControl('', [Validators.required]),
        });
        this.resetForm = new FormGroup({
            email: new FormControl('', [Validators.required, GCValidators.validateEmail]),
        });
        this.resetFormIsOpen = false;
        this.resetRequestSuccessful = false;
        this.loginError = '';
        this.resetError = '';
        if (router.url === '/login/reset') {
            this.resetFormIsOpen = true;
        }
    }
    LoginComponent.prototype.login = function () {
        var _this = this;
        if (this.loginForm.valid) {
            this.loginError = '';
            this.loginForm.disable();
            this.auth
                .login(this.loginForm.value.email, this.loginForm.value.password)
                .then(function (result) {
                _this.router.navigate(['/dashboard']);
            })
                .catch(function (error) {
                var message = error.body.error;
                if (message === 'Account is not active.') {
                    _this.loginError = 'finishRegistration';
                }
                else if (message === 'No valid licence could be found for this account.') {
                    _this.loginError = 'noValidLicence';
                }
                else {
                    _this.loginError = 'general';
                }
                _this.loginForm.enable();
            });
        }
    };
    LoginComponent.prototype.openResetForm = function (e) {
        e.preventDefault();
        this.resetFormIsOpen = true;
    };
    LoginComponent.prototype.closeResetForm = function (e) {
        e.preventDefault();
        this.resetFormIsOpen = false;
    };
    LoginComponent.prototype.resetPW = function (event) {
        var _this = this;
        event.preventDefault();
        if (this.resetForm.valid) {
            this.resetForm.disable();
            this.user
                .requestPasswordReset(this.resetForm.value.email)
                .then(function (result) {
                _this.resetRequestSuccessful = true;
            })
                .catch(function (error) {
                if (error.body.error === 'No account found.') {
                    _this.resetError = 'noAccount';
                }
                _this.resetForm.enable();
            });
        }
    };
    return LoginComponent;
}());
export { LoginComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/login/login.component.ts.pre-build-optimizer.js